<template>
  <div>
    
    <get-weight title="" :domVisible='dislogType.weight' :list="dislogData" :dialogClass="'weight alertWeightList'" @closeDialog="closeDialog" v-if='dislogType.weight' />
  <div class='oversea full_layout' v-loading.fullscreen="disabled">
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_01.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_02.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_03.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_04.jpg"><span @click="ShippingFee"></span></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_05.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_06.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea/oversea_07.jpg"></div>
  </div>
</div>
</template>
<script>
import bus from '@/api/bus';
import GetWeight from "@/components/dialog/weight"; // 稱重
export default {
  name: '',
  components: { GetWeight },
  data() {
    return {
      dislogType: this.$enumInfo.dislogType,
      dislogData:{},
      disabled:false
    }
  },
  watch: {
  },
  mounted() {},
  created() {
    bus.$emit('headerTitle', this.$t('title.processIntroduction'));
  },
  methods: {
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
    },
    ShippingFee() {
      // 价格列表
      let that = this
      //that.loading = true;
      let data = { pageIndex: 1, pageSize: 99}
      that.dislogData=data
      that.dislogType.weight = true;
      // this.$get(this.$interface.GetWeightList, data).then(res => {
      //   if (res.Result != 0) {

      //     that.disabled = false;
      //     var result = res.Data
      //     let htmlLi = ''
      //     result.map(item => {
      //       htmlLi += '<li><span>' + (item.MinWeight>0?item.MinWeight+'kg':item.MinWeight) + ' ~ ' + item.MaxWeight + `kg（${that.$t('base.included')}）</span><span>$` + item.WeightFeeUSD + '</span></li>'
      //     })
      //     let html = `<div class="tab_dasap">
      //           <ul class="tab_dasap_ul">
      //             <li class="tab_dasap_title"><span>Weight</span><span>${that.$t('base.internationalShippingFee')}</span>
      //             </li>
      //             ` + htmlLi + `
      //           </ul>
      //         </div>`
      //     this.$alert(html, '', {
      //       confirmButtonText: this.$t('base.confirm'),
      //       customClass: "confirmBox alertWeightList",
      //       lockScroll: false,
      //       dangerouslyUseHTMLString: true,
      //       callback: action => {}
      //     });
      //   }
      // })

      // this.$confirm(html, '', {
      //     confirmButtonText: 'Yes',
      //     cancelButtonText: '',
      //     customClass: "confirmBox",
      //     lockScroll: false,
      //     dangerouslyUseHTMLString: true
      //   }).then(() => {
      //     //this.setOrder(obj)
      //   }).catch(() => {});
    },
  },
}

</script>
<style scoped>
.oversea{
  margin-top: 24px;
}
.oversea img{
  width: 100%;
  display: block;
  overflow: hidden;
}
.oversea>div{
  position: relative;
}
.oversea>div>span{
  position: absolute;
  width: 263px;
    height: 38px;
    top: 193px;
    right: 341px;
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/oversea.vue